"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemV2IDL = exports.AvatarIDL = exports.StakingIDL = exports.NamespaceIDL = exports.MatchesIDL = exports.PlayerIDL = exports.ItemIDL = void 0;
var raindrops_item_1 = require("./raindrops_item");
Object.defineProperty(exports, "ItemIDL", { enumerable: true, get: function () { return raindrops_item_1.IDL; } });
var raindrops_player_1 = require("./raindrops_player");
Object.defineProperty(exports, "PlayerIDL", { enumerable: true, get: function () { return raindrops_player_1.IDL; } });
var raindrops_matches_1 = require("./raindrops_matches");
Object.defineProperty(exports, "MatchesIDL", { enumerable: true, get: function () { return raindrops_matches_1.IDL; } });
var raindrops_namespace_1 = require("./raindrops_namespace");
Object.defineProperty(exports, "NamespaceIDL", { enumerable: true, get: function () { return raindrops_namespace_1.IDL; } });
var raindrops_staking_1 = require("./raindrops_staking");
Object.defineProperty(exports, "StakingIDL", { enumerable: true, get: function () { return raindrops_staking_1.IDL; } });
var raindrops_avatar_1 = require("./raindrops_avatar");
Object.defineProperty(exports, "AvatarIDL", { enumerable: true, get: function () { return raindrops_avatar_1.IDL; } });
var itemv2_1 = require("./itemv2");
Object.defineProperty(exports, "ItemV2IDL", { enumerable: true, get: function () { return itemv2_1.IDL; } });
